'use client';

import { ToastType } from '@shared/ui-components/toast/constants/constants';
import { useGlobalToastContext } from '@shared/ui-components/toast/context/global-toast-context';

import { useGlobalCmsContentContext } from '../../components/providers/global-cms-context';

export const useAddDefaultErrorToast = () => {
  const { addToast } = useGlobalToastContext();
  const { cmsContent: globalCmsContent } = useGlobalCmsContentContext();

  return () => {
    addToast(
      {
        closeButtonLabel: globalCmsContent.closeButtonLabel,
        description: globalCmsContent.somethingWentWrong,
        type: ToastType.ERROR,
      },
      { timeout: 0 }
    );
  };
};
